import body         from "../../../index.module.scss";
import classes      from "./FirstStep.module.scss";

import SectionTitle from "../../Titles/SectionTitle/SectionTitle";
import ColoredBlock from './../../ColoredBlock/ColoredBlock';
import Result       from './Result/Result';
import Meeting      from "./Result/Meeting/Meeting";


const FirstStep =  () => {
  return (
    <section id="Analys" className={classes.FirstStep}>
      <ColoredBlock 
        customClass={classes.ColoredBlock}
        CustomNumClass={classes.ColoredNum}
        number="1"/>
      <div className={body.container}>
        <div className={classes.Wrapper}>
          <div className={classes.Analys}>
              <SectionTitle text={<>Анализ <span>текущей ситуации</span> </>} customClass={classes.Title}/>

            <p className={classes.Description}>
              После обращения к нам Заказчика в 2016 году в первую очередь для понимания текущей ситуации мы провели анализ всех данных, которые нам предоставили. Объём данных был очень большой – это отчёты предыдущих подрядчиков, данные Яндекс Вебмастера, Яндекс Метрики, Google Search Console. Кроме этого мы анализировали данные сайтов некоторых дилеров компании.
              <b>Работы по анализу всей ситуации и построению прогнозов заняли у нас около месяца.</b>
            </p>
         </div>
       </div>
        <Result/>
        <Meeting/>
      </div>          
    </section>
  )
}

export default FirstStep;